var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.405,
    height: 21.405,
    viewBox: "0 0 21.405 21.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close",
    transform: "translate(-66.89 -279.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_close_18px",
    d: "M24.875,5.521,22.824,3.47l-8.651,8.651L5.521,3.47,3.47,5.521l8.651,8.651L3.47,22.824l2.051,2.051,8.651-8.651,8.651,8.651,2.051-2.051-8.651-8.651Z",
    transform: "translate(63.42 276.053)",
    fill: "#e1e3ed"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d12a8703f3598489d9818b90163f1d52.svg";
export { ForwardRef as ReactComponent };